<div class="confirmation-popup">
  @if (data.title) {
    <h2 mat-dialog-title class="confirmation-popup__title">
      @if (data.icon) {
        <span class="confirmation-popup__icon-badge" [class.confirmation-popup__icon-badge--warn]="data.warn">
          <mat-icon class="material-symbols-outlined">{{ data.icon }}</mat-icon>
        </span>
      }
      <span>{{ data.title }}</span>
    </h2>
  }
  <mat-dialog-content>
    <p class="confirmation-popup__message">{{ data.message }}</p>
  </mat-dialog-content>
  <mat-dialog-actions align="end" class="confirmation-popup__actions">
    <button mat-stroked-button mat-dialog-close>{{ data.cancelText ?? 'Cancel' }}</button>
    <button
      mat-flat-button
      class="confirmation-popup__confirm"
      [class.confirmation-popup__confirm--warn]="data.warn"
      (click)="onConfirm()">
      {{ data.confirmText ?? 'Confirm' }}
      @if (data.confirmArrows) {
        <span class="sgl-arrows" aria-hidden="true"></span>
      }
    </button>
  </mat-dialog-actions>
</div>
